import React from 'react';
import { APPEARANCES, Heading } from '../../PageElements/Heading';
import style from './singleExample.scss';
import { ExampleContent } from './ExampleContent';

export const SingleExample = ({
  example,
  data,
  prefix,
  isSingleExample,
  JSLayoutType,
}) => (
  <React.Fragment>
    {example.title && (
      <Heading
        appearance={APPEARANCES.H5}
        className={style.singleExampleTitle}
        dataHook="example-title"
      >
        {example.title}
      </Heading>
    )}
    <ExampleContent
      example={example}
      data={data}
      prefix={prefix}
      isSingleExample={isSingleExample}
      JSLayoutType={JSLayoutType}
    />
  </React.Fragment>
);
